import { useMemo } from "react";

import * as Yup from "yup";

import { AssignmentPriority } from "@/api";
import { useTranslation } from "@/translations";

import { AssignmentFormValues, AssignmentMaxLength, AssignmentPriorityOption } from "../AssignmentForm.types";

export function useAssignmentFormOptions() {
  const { t } = useTranslation();

  const priorityOptions = useMemo<AssignmentPriorityOption[]>(
    () => [
      {
        id: AssignmentPriority.Low,
        label: t("assignments.creationDialog.priorityValues.low"),
      },
      {
        id: AssignmentPriority.Normal,
        label: t("assignments.creationDialog.priorityValues.normal"),
      },
      {
        id: AssignmentPriority.High,
        label: t("assignments.creationDialog.priorityValues.high"),
      },
    ],
    [t]
  );

  const validationSchema = useMemo(() => {
    return Yup.object().shape<{ [Property in keyof AssignmentFormValues]?: Yup.AnySchema }>({
      dueDate: Yup.date().required(
        t("common.validation.fieldRequired", {
          fieldName: t("assignments.creationDialog.dueDate"),
        })
      ),
      description: Yup.string()
        .required(
          t("common.validation.fieldRequired", {
            fieldName: t("assignments.creationDialog.description"),
          })
        )
        .max(AssignmentMaxLength.description, ({ max }) => t("common.validation.maxLength", { max })),
      priority: Yup.mixed<AssignmentPriority>()
        .oneOf(Object.values(AssignmentPriority))
        .required(
          t("common.validation.fieldRequired", {
            fieldName: t("assignments.creationDialog.priority"),
          })
        ),
      assignedCounselorId: Yup.string().required(
        t("common.validation.fieldRequired", {
          fieldName: t("common.counselor"),
        })
      ),
    });
  }, [t]);

  return { priorityOptions, validationSchema };
}
